import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { LuIconModule } from 'lu-icon';
import { CharactersLeftModule } from '../../pipes/characters-left/characters-left.module';
import { DefaultFieldWrapperComponent } from './default-field.component';

const declarations = [DefaultFieldWrapperComponent];

const imports = [
	CommonModule,
	ReactiveFormsModule,
	TranslateModule,
	LuIconModule,
	CharactersLeftModule,
	FormlyModule.forChild()
];

@NgModule({
	imports,
	declarations,
	exports: [...declarations]
})
export class DefaultFieldModule {}
